<!-- header section -->
<header>
  <div class="container-fluid">
    <video src="../../../assets/pexels-vanessa-loring-5857694.mp4" autoplay muted loop></video>
    <div class="overlay">
      <div class="container d-flex flex-column  text-center">
        <h1 class="w-100 p-lg-4">welcome to kitchen jungle</h1>
        <p class="w-100 ">your way to healthy life style</p>
        <a class="gen-btn font"> learn more</a>
      </div>
    </div>
  </div>
</header>


<!-- our Goals sec -->
<section class="goals-sec sec-padding">
  <div class="container d-flex flex-lg-row flex-column justify-content-lg-between align-items-center">
    <div class="goals-sec_img w-50 w-md-100 img-sec">
        <img src="/assets/images/goals.jpg" alt="goals-image" class="img-fluid">
    </div>
    <div class="goals-sec_content w-lg-50 p-5">
      <h2 class="text-lg-left pb-4">OUR Goals</h2>
      <hr class="m-lg-3">
      <ul class="text-left">
        <li class="p-lg-2 text-muted">Get active and try to be a healthy weight.</li>
        <li class="p-lg-2 text-muted ">Cut down on saturated fat and sugar.</li>
        <li class="p-lg-2 text-muted">Base your meals on starchy foods.</li>
        <li class="p-lg-2 text-muted">Drink plenty of water.</li>
        <li class="p-lg-2 text-muted" >Help you to make your own life syle routine</li>
      </ul>
    </div>
  </div>
</section>

<!-- about us section-->

<section class="about-us sec-padding text-center" >
  <div class="container">
    <h5>what we do ?</h5>
    <h2 class="about-us-head">
      the story About us
    </h2>
    <hr>
    <p class="text-center">Kitchen Jungle is truly my own little passion project, gaining more and more traction each day. I hope you enjoy
      browsing my site and all of the unique content I have to offer. Take a look around; perhaps you’ll discover what
      fuels you as well. Read on and enjoy!</p>
  </div>
</section>

<!-- weight calculator -->
<section class="weightcalc sec-padding " >
  <div class="container">
    <div class="row  text-center">
      <h2 class="col-12 text center">Lets calculate your BMI</h2>
      <hr class="m-auto">
    </div>
    <div class="row my-1">
      <form class="sec-padding col-md-12" [formGroup]="userdata" (ngSubmit)="bmimethod()">
        <label for="weight" class="col-4 text-right text-muted my-4">Your weight in Kg *</label>
        <input type="number" id="weight" class="form-control  col-6 email-field" placeholder="enter your weight" formControlName="userweight">
        <label for="height" class="col-4 text-right text-muted my-3">Your Height in CM *</label>
        <input type="number" id="height" class=" form-control col-6 email-field"  placeholder="enter your height" formControlName="userheight">
        <div class="text-center">
          <button [disabled]="userdata.invalid == true" type="submit" class=" gen-btn mt-5" >Calculate</button>
        </div>
      </form>
    </div>
    <div class="text-center p-2">
      <h2>{{bmimessage}}</h2>
    </div>
  </div>
</section>
<section class="subscribe sec-padding">
  <div class="container">
    <div class="subsribe-content m-auto w-100 text-center">
      <h2 class=" mb-5">Subscribe now</h2>
      <hr class="m-auto">
      <p class=" mt-4  text-muted">Stay updated with our last recipes and Diets types</p>
      <form class="row mt-5 justify-content-center">
        <input type="email" class="col-8 col-md-6 email-field text-left" placeholder="Type your Email" required>
        <button class="gen-btn col-4 col-md-2 subs-btn">Subscribe</button>
      </form>
    </div>
  </div>
</section>
